import styledC from 'styled-components';
const TriggerWrapper = styledC.div.withConfig({
  displayName: "TriggerWrapper",
  componentId: "sc-1elx9m1-0"
})(["display:block;"]);
export default TriggerWrapper;
//# sourceMappingURL=TriggerWrapper.js.map